import * as React from 'react';
import { ShippingMethodsListContainer } from '../containers/ShippingMethodsListContainer.js';
import { SelectedShippingMethodContainer } from '../containers/SelectedShippingMethodContainer.js';

const ShippingMethods = ({ shippingMethodsAsides  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-shipping-methods"
    }, /*#__PURE__*/ React.createElement(ShippingMethodsListContainer, {
        asides: shippingMethodsAsides
    })), /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, null));
};

export { ShippingMethods };
//# sourceMappingURL=ShippingMethods.js.map
